import styled, {keyframes} from "styled-components";
import {
  Image as AntImage,
  Row as AntRow,
  Col as AntCol,
  Button as AntButton,
} from "antd";
import { SportDefaultIMG } from "@assets";

export const RootContainer = styled.div`
  border-bottom: 1px solid rgba(222, 237, 255, 1);
`;

export const Row = styled(AntRow)`
  border-radius: 12px;
  padding: 8px 0px 16px 0px;
`;

export const Col = styled(AntCol)`
  width: 33%;
  text-align: center;
  margin-bottom: 8px;
`;

export const SubContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(222, 237, 255, 1);
  border-radius: 16px;
  padding: 13px 8px;
`;

export const Image = styled(AntImage).attrs({
  alt: "gameicon",
  fallback: SportDefaultIMG,
  preview: false,
})`
  width: 40px !important;
  height: 40px !important;
  object-fit: cover;
  aspect-ratio: 1;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0px 3px 8px 0px rgba(0, 46, 86, 0.2);
`;

export const Label = styled.div`
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 10px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 16px;
`;

export const Title = styled.div`
  text-align: center;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 6px 12px;
  background: rgba(217, 217, 217, 1);
  border-radius: 16px;
  width: 135px;
`;

export const Button = styled(AntButton)`
  height: 30px !important;
  font-size: 12px !important;
  @media screen and (max-width: 390px) {
    font-size: 10px !important;
  }
  @media screen and (max-width: 330px) {
    font-size: 9px !important;
  }
`;


const marquee = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const MarqueeLabel = styled.div`
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 10px;
  white-space: nowrap;

  animation: ${marquee} 13s linear infinite;

  @media screen and (max-width: 315px) {
    font-size: 11px;
  }

  @media screen and (max-width: 290px) {
    font-size: 10px;
  }
`;
